export const privacyContent = `
<h2>Integritetspolicy</h2>
<p><strong>Version 1.2</strong></p>

<h3>Innehållsförteckning</h3>
<ol>
  <li>Allmänt</li>
  <li>Vilka personuppgifter samlar vi in och varför?</li>
  <li>Hur samlar vi in dina personuppgifter?</li>
  <li>Hur skyddar vi dina personuppgifter?</li>
  <li>Delning av personuppgifter med tredje-part</li>
  <li>Internationella dataöverföringar</li>
  <li>Dina rättigheter som registrerad</li>
  <li>Hantering av användarkonton och köptransaktioner</li>
  <li>Användning av cookies och liknande tekniker</li>
  <li>Behandling av särskilda kategorier av personuppgifter</li>
  <li>Videoövervakning av köptransaktioner</li>
  <li>Hantering av ringa stöld och stöld</li>
  <li>Uppdateringar och ändringar i denna policy</li>
  <li>Personuppgifter och tävlingar</li>
  <li>Lista underleverantörer och partners</li>
</ol>

<h3>1. Allmänt</h3>
<p>Denna integritetspolicy (”Policy”) beskriver hur Ziplink AB, org. nr 559459-8350 med adress, Utjordsvägen 11, 802 91 Gävle: samlar in, använder, lämnar ut och lagrar dina personuppgifter.</p>
<p>Vi är engagerade i att skydda din personliga integritet och strävar efter att du ska känna dig säker när du använder våra tjänster.</p>
<p>Ziplink AB är personuppgiftsansvarig för de personuppgifter som behandlas och vi vill med denna Integritetspolicy visa hur vi säkerställer att dina personuppgifter behandlas i enlighet med gällande personuppgiftslagstiftning.</p>
<ul>
  <li>Vilka typer av personuppgifter vi behandlar.</li>
  <li>För vilka syften.</li>
  <li>Baserat på vilken laglig grund.</li>
  <li>Varifrån vi inhämtar uppgifterna.</li>
  <li>Vem vi delar dem med.</li>
  <li>Hur länge de sparas.</li>
  <li>Vilka rättigheter du har som registrerad.</li>
</ul>
<p>Vi uppmuntrar dig att noga läsa igenom Policyn för att förstå vår hantering av dina personuppgifter då vi kan behöva uppdatera denna Policy. Den senaste versionen av Policyn finns alltid tillgänglig på vår webbplats.</p>
<p>Om du har några frågor eller funderingar angående vår hantering av dina personuppgifter eller om du vill använda dig av dina rättigheter i enlighet med GDPR vänligen kontakta oss på: <a href="mailto:info@ziplink.se">info@ziplink.se</a>.</p>

<h3>2. Vilka personuppgifter samlar vi in och varför?</h3>
<p>Ziplink AB samlar in och behandlar personuppgifter i syfte att tillhandahålla och förbättra våra tjänster, för att möjliggöra enkel och bekväm beställning och leverans av mat och dryck, samt för att upprätthålla en säker och effektiv verksamhet.</p>
<ul>
  <li><strong>Kontaktinformation:</strong> namn, adress, e-postadress och telefonnummer.</li>
  <li><strong>Transaktionsdata:</strong> köphistorik, beställningsdetaljer och betalningsinformation.</li>
  <li><strong>Användningsdata:</strong> loggfiler och enhetsinformation för att förbättra användarupplevelsen.</li>
  <li><strong>Kommunikationsdata:</strong> feedback, klagomål eller förfrågningar från dig.</li>
</ul>

<h3>3. Hur samlar vi in dina personuppgifter?</h3>
<p>Vi samlar in personuppgifter direkt från dig, genom registrering, köp och användning av våra tjänster, eller från samarbetspartners och offentliga källor.</p>

<h3>4. Hur skyddar vi dina personuppgifter?</h3>
<p>Vi använder avancerade tekniska och organisatoriska åtgärder, såsom kryptering, brandväggar, utbildning av personal och strikt åtkomstkontroll, för att säkerställa att dina uppgifter hanteras säkert.</p>

<h3>5. Delning av personuppgifter med tredje parter</h3>
<p>Dina personuppgifter delas endast när det är nödvändigt, t.ex., med betalningsprocessorer, leveranstjänster eller vid rättsliga krav.</p>

<h3>6. Internationella dataöverföringar</h3>
<p>Vid dataöverföringar utanför EES säkerställer vi att adekvata skyddsnivåer är på plats, såsom standardavtalsklausuler eller uttryckligt samtycke.</p>

<h3>7. Dina rättigheter som registrerad</h3>
<p>Du har rätt till tillgång, rättelse, radering, begränsning av behandling, dataportabilitet och att göra invändningar mot vissa typer av behandling.</p>

<h3>8. Hantering av användarkonton och köptransaktioner</h3>
<p>Vi hanterar och lagrar användarkontodata och köptransaktioner enligt lagliga krav, med tydliga rutiner för radering av inaktiva konton.</p>

<h3>9. Användning av cookies och liknande tekniker</h3>
<p>Vi använder cookies för att förbättra våra tjänster och ge en bättre användarupplevelse.</p>

<h3>10. Behandling av särskilda kategorier av personuppgifter</h3>
<p>Vi undviker att behandla känsliga uppgifter, men kan samla in identifierbara uppgifter vid t.ex. videoövervakning av köptransaktioner.</p>

<h3>11. Videoövervakning av köptransaktioner</h3>
<p>Videoövervakning används för att säkerställa tjänstens säkerhet och kvalitet, med lagring av material i högst 14 dagar.</p>

<h3>12. Hantering av ringa stöld och stöld</h3>
<p>Vi har tydliga processer för att hantera oegentligheter, inklusive kontostängning och eventuella polisiära åtgärder.</p>

<h3>13. Uppdateringar och ändringar i denna policy</h3>
<p>Vi förbehåller oss rätten att göra ändringar i denna policy och uppmuntrar dig att regelbundet kontrollera den senaste versionen på vår webbplats.</p>

<h3>14. Personuppgifter och tävlingar</h3>
<p>Vid tävlingar samlar vi in personuppgifter för att säkerställa leverans av priser, med lagring i högst tre månader efter avslutad tävling.</p>
`;

